import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap/js/dist/collapse'
import 'leaflet/dist/leaflet.css';
import './utils/languages/i18n'
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import { useDispatch, useSelector } from 'react-redux';
import { login, selectUser } from './utils/redux/userSlice';
import { useEffect, useState } from 'react';
import { validateToken } from './utils/services/user.service';
import LoadingComponent from './components/LoadingComponent/Loading.component';
import MainPage from './components/MainPage/MainPage.component';
import { useTranslation } from 'react-i18next';
import CompaniesPage from './pages/CompaniesPage';
import UsersPage from './pages/UsersPage';
import InstalationPage from './pages/InstalationsPage';
import MachinesPage from './pages/MachinesPage';
import DashboardPage from './pages/DashboardPage';
import UserInstalationsPage from './pages/UserInstalationPage';
import UserMachinesPage from './pages/UserMachinesPage';
import { LANGUAGES } from 'aw-consts';
import Page3D from './pages/3DPage';
import ProductionPage from './pages/ProductionPage';
import ModulesPage from './pages/ModulesPage';
import ApiModulePage from './pages/ApiModulePage';
import AlarmModulePage from './pages/AlarmModulePage';
import ReportingModulePage from './pages/ReportingModulePage';
import UpdateModulePage from './pages/UpdateModulePage';
import AnalitycModulePage from './pages/AnalitycModulePage';
import DigitalTwinModulePage from './pages/DigitalTwinModulePage';
import AutoRegistringModulePage from './pages/AutoRegistringModulePage';
import PaymentModulePage from './pages/PaymentModulePage';
import AsistancesModulePage from './pages/AsistancesModulePage';
import MarketingModulePage from './pages/MarketingModulePage';
import EndUserPage from './pages/EndUserPage';
import DemosPage from './pages/DemosPage';
import SignUpPage from './pages/SingupPage';
import FinalUserValidateEmail from './pages/FinalUserValidateEmail';
import KnowledgeModulePage from './pages/KnowledgeModulePage';
import LogsModulePage from './pages/LogsModulePage';
import CAEModulePage from './pages/CAEModulePage';

const App = () => {
  const user = useSelector(selectUser)
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true);
  const { i18n } = useTranslation();

  useEffect(() => {
    const token = localStorage.getItem('IbToken')
    if (token) {
      validateToken(token).then((json) => {

        const userInfo = {
          email: json.email,
          user: json.name,
          role: json.rol,
          iduser: json.iduser,
          token: json.token,
          auth: true,
          company: json.company
        }

        switch (json.language) {
          case LANGUAGES.Catalan:
            i18n.changeLanguage("cat");
            break;

          case LANGUAGES.Castellano:
            i18n.changeLanguage("es");
            break;

          case LANGUAGES.Ingles:
            i18n.changeLanguage("eng");
            break;
          case LANGUAGES.Frances:
            i18n.changeLanguage("fr");
            break;
          default:
            i18n.changeLanguage("es");
            break;
        }

        dispatch(
          login(userInfo)
        );
      }).catch((e) => {
        console.log('ValidateToken Error', e);

      }).finally(() => {
        loadPage()
      })
    } else {
      loadPage()
    }
    loadPage()

  }, [dispatch, i18n])

  const loadPage = () => {
    setTimeout(() => { setLoading(false) }, 1000)
  }


  const validateUser = () => {
    return user.auth ? <Outlet /> : <Navigate to="/login" />
  }

  const NavigateTo = () => {
    return <Navigate to="/modules" />
  }

  const onChangeLang = (languageValue: string) => {
    i18n.changeLanguage(languageValue);
  }

  if (loading) return <LoadingComponent />
  else {
    const routerBasename = process.env.PUBLIC_URL && process.env.PUBLIC_URL !== "." ? process.env.PUBLIC_URL : "/"

    return (
      <BrowserRouter basename={routerBasename}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path='/validate' element={<FinalUserValidateEmail />} />
          <Route path="*" element={validateUser()}>
            <Route path="*" element={<MainPage changeLang={onChangeLang} />} >
              <Route path="*" element={NavigateTo()} />
              <Route path="home" element={<DashboardPage />} />
              <Route path="companies" element={<CompaniesPage />} />
              <Route path="users" element={<UsersPage />} />
              <Route path="containers" element={<InstalationPage />} />
              <Route path="machines" element={<MachinesPage />} />
              <Route path="userInstalations" element={<UserInstalationsPage />} />
              <Route path="userInstalations/:idinstalation" element={<UserInstalationsPage />} />
              <Route path="userMachines" element={<UserMachinesPage />} />
              <Route path="userMachines/:idmachine" element={<UserMachinesPage />} />
              <Route path="modules" element={<ModulesPage />} />
              <Route path="demos" element={<DemosPage />} />
              <Route path="modules/production" element={<ProductionPage />} />
              <Route path="modules/alarms" element={<AlarmModulePage />} />
              <Route path="modules/reporting" element={<ReportingModulePage />} />
              <Route path="modules/api" element={<ApiModulePage />} />
              <Route path="modules/update" element={<UpdateModulePage />} />
              <Route path="modules/analytic" element={<AnalitycModulePage />} />
              <Route path="modules/digitaltwin" element={<DigitalTwinModulePage />} />
              <Route path="modules/3d" element={<Page3D />} />
              <Route path="modules/autoregistring" element={<AutoRegistringModulePage />} />
              <Route path="modules/payment" element={<PaymentModulePage />} />
              <Route path="modules/asistances" element={<AsistancesModulePage />} />
              <Route path="modules/marketing" element={<MarketingModulePage />} />
              <Route path="modules/enduser" element={<EndUserPage />} />
              <Route path="modules/knowledge" element={<KnowledgeModulePage />} />
              <Route path="modules/logs" element={<LogsModulePage />} />
              <Route path="modules/cae" element={<CAEModulePage />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter >
    );
  }
}

export default App;
